 import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import { FaArrowLeft, FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";

export default function Login() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();

  const showMessage = (text, type = "success") => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 3000);
  };

  const handleBack = () => {
    navigate("/database-key");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await api.AssetCheckLogin(userName, password);
      const table = result?.AssetCheckLoginApi?.Table || [];
      const loginData = table[0];
      if (loginData?.Loginmsg === "Success") {
        showMessage("✅ Login Successful!", "success");
        sessionStorage.setItem("userName", loginData.UsrName);
        sessionStorage.setItem("userId", loginData.Usrid);
        navigate("/dashboard", { replace: true });
      } else {
        showMessage("❌ Username or Password incorrect", "error");
      }
    } catch (error) {
      console.error("Login failed:", error);
      showMessage("❌ Login Failed: " + error.message, "error");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-500 to-purple-600 px-4">
      {/* Floating Back Button */}
      <button
        onClick={handleBack}
        className="absolute top-6 left-6 text-white text-xl p-2 rounded-full bg-black/30 hover:bg-black/50 transition"
        aria-label="Back"
      >
        <FaArrowLeft />
      </button>

      {/* Login Card */}
      <div className="w-full max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-xl p-8 space-y-6">
        <h2 className="text-3xl font-bold text-gray-800 dark:text-white text-center">
          Welcome Back
        </h2>
        <p className="text-center text-gray-500 dark:text-gray-300">
          Please login to your account
        </p>

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Username */}
          <div className="relative">
            <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              required
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="Username"
              className="w-full pl-10 pr-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 dark:bg-gray-700 dark:text-white"
            />
          </div>

          {/* Password */}
          <div className="relative">
            <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type={showPassword ? "text" : "password"}
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="w-full pl-10 pr-10 py-3 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 dark:bg-gray-700 dark:text-white"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
              tabIndex={-1}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition duration-200"
          >
            Login
          </button>
        </form>

        {/* Message */}
        {message && (
          <div
            className={`text-center py-2 rounded ${
              message.type === "success"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {message.text}
          </div>
        )}
      </div>
    </div>
  );
}
